export const freshDesk = () => {       
    const wid_id = 153000002170;
    const lang = "es";
    const scriptWidget = `
    window.fwSettings = {
        widget_id: ${wid_id},
        locale: "${lang}",
    };
    !(function () {
        if ("function" != typeof window.FreshworksWidget) {
        var n = function () {
            n.q.push(arguments);
        };
        (n.q = []), (window.FreshworksWidget = n);
        }
    })();
    window.FreshworksWidget("hide", "launcher");
    `;

    if (!window.fwSettings) {
        const body = document.querySelector("body");
        const script = document.createElement("script")
        const js = document.createTextNode(scriptWidget);
        script.appendChild(js);
        body?.appendChild(script);
        const cdn = document.createElement("script");
        cdn.src = `https://widget.freshworks.com/widgets/${wid_id}.js`;
        cdn.async = true;
        cdn.defer = true;
        body?.appendChild(cdn);
    }

}



